import './Footer.css';
import { FOOTER_CLARO } from '../../Config.js'

const Footer = () => {
    return(
        <div className={FOOTER_CLARO ? 'footer' : 'footer oscuro'}>
            <a href="https://agenciaforest.com/" target='_blank'><img src='./images/forest.png' alt='logo forest' /></a>
        </div>
    );
}

export default Footer;